<template>
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Regularity')}}:</label>
                <div class="col-sm-9">
                    <select-picker :form="form"
                                   :field="'trip_regularity_type'"
                                   :items="$store.state.regularityTypes"
                                   :value="'index'"
                                   :text="'name'"
                                   @change="handleRegularityType">
                    </select-picker>
                </div>
            </div>
            <div class="form-group form-row" v-if="form.trip_regularity_type === 2">
                <div class="col-sm-12">
                    <div class="form-group form-row">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Each')}}:</label>
                        <div class="col-sm-3">
                            <div class="input-group spinner">
                                <form-input @change="form.days < 2 ? form.days = 2 : ''" :form="form" :field="'days'" :inputClass="'base_input text-right pr-5'"></form-input>
                                <div class="input-group-btn-vertical">
                                    <button class="btn" type="button" @click="incrementDays"><i class="mdi mdi-menu-up"></i></button>
                                    <button class="btn" type="button" @click="decrementDays"><i class="mdi mdi-menu-down"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="text-left pt-2">
                                <span class="fs-12">{{i18n('- day')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group form-row" v-if="form.trip_regularity_type === 3">
                <div class="offset-sm-3 col-sm-9">
                    <ul class="list-unstyled days-list">
                        <li>
                            <span class="text">{{i18n('Mon')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="mon" v-model="form.days[1]" @change="setWeekDays()">
                                <label class="custom-control-label" for="mon"></label>
                            </div>
                        </li>
                        <li>
                            <span class="text">{{i18n('Tu')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="form.days[2]" @change="setWeekDays()">
                                <label class="custom-control-label" for="customCheck2"></label>
                            </div>
                        </li>
                        <li>
                            <span class="text">{{i18n('We')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck3" v-model="form.days[3]" @change="setWeekDays()">
                                <label class="custom-control-label" for="customCheck3"></label>
                            </div>
                        </li>
                        <li>
                            <span class="text">{{i18n('Th')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck4" v-model="form.days[4]" @change="setWeekDays()">
                                <label class="custom-control-label" for="customCheck4"></label>
                            </div>
                        </li>
                        <li>
                            <span class="text">{{i18n('Fr')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck5" v-model="form.days[5]" @change="setWeekDays()">
                                <label class="custom-control-label" for="customCheck5"></label>
                            </div>
                        </li>
                        <li>
                            <span class="text text-danger">{{i18n('Sa')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck6" v-model="form.days[6]" @change="setWeekDays()">
                                <label class="custom-control-label" for="customCheck6"></label>
                            </div>
                        </li>
                        <li>
                            <span class="text text-danger">{{i18n('Su')}}:</span>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="1" v-model="form.days[0]" @change="setWeekDays()">
                                <label class="custom-control-label" for="1"></label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group form-row" v-if="form.trip_regularity_type === 4">
                <div class="offset-sm-3 col-sm-9">
                    <div class="button-group">
                        <button type="button" class="btn base_btn waves-effect"
                                @click="monthRegularityType = 1; form.days.type = 1"
                                :class="{'green': monthRegularityType === 1}"
                        >{{i18n('Various')}}
                        </button>
                        <button type="button" class="btn base_btn waves-effect"
                                @click="monthRegularityType = 2; form.days.type = 2; form.days.days = []; customDays = ''"
                                :class="{'green': monthRegularityType === 2}"
                        >{{i18n('Even')}}
                        </button>
                        <button type="button" class="btn base_btn waves-effect"
                                @click="monthRegularityType = 3; form.days.type = 3; form.days.days = []; customDays = ''"
                                :class="{'green': monthRegularityType === 3}"
                        >{{i18n('Odd')}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="form-group form-row" v-if="monthRegularityType === 1 && form.trip_regularity_type === 4">
                <div class="offset-sm-3 col-sm-9">
                    <input type="text" class="form-control base_input"
                           :placeholder="i18n('For example 1-5, 9, 13')"
                           v-model="customDays"
                           @change="splitDays">
                    <span v-if="customDays"><b>{{i18n('Days')}}: </b> <template v-for="day in form.days.days">{{day + ', '}}</template></span>
                </div>
            </div>
            <div class="form-group form-row">
                <template v-if="form.trip_regularity_type === 5">
                    <div class="col-sm-9 offset-sm-3">
                        <div class="date-group" style="border: none">
                            <v-date-picker :is-inline="true" mode='multiple'
                                           :min-date="daysArrayMinDate"
                                           v-model='daysArray'
                                           show-caps
                            ></v-date-picker>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Period')}}:</label>
                    <div class="col-sm-9">
                        <div class="input-group">
                            <v-date-picker :is-inline="true" mode='range'
                                           :min-date="new Date()"
                                           v-show="isRangeMode"
                                           v-model="range"
                                           show-caps
                            ></v-date-picker>
                            <div class="d-flex flex-column">
                                <v-date-picker :is-inline="true" mode='multiple'
                                               v-model="demoDays"
                                               v-show="!isRangeMode"
                                               :available-dates="availableDays"
                                               show-caps
                                ></v-date-picker>
                                <a href="javascript:void(0)" class="back_link" v-if="!isRangeMode" @click.prevent="isRangeMode = true">Назад</a>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12" for="reserved_seats">{{i18n('Reserved seats')}}:</label>
                <div class="col-sm-9">
                    <input type="text" class="form-control" id="reserved_seats"
                           v-model="custom_seats"
                           placeholder="1-5,7,8,10"
                           @change="splitSeats"
                    >
                    <span v-if="form.reserved_seats"><b>{{i18n('Seats')}}: </b> <template v-for="seat in form.reserved_seats">{{seat + ', '}}</template></span>
                </div>
            </div>
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12" for="reserved_minutes">{{i18n('Reserved minutes')}}:</label>
                <div class="col-sm-6">
                    <form-input :form="form" :field="'reserved_minutes'" id="reserved_minutes"></form-input>
                </div>
                <div class="col-sm-3 mt-2">
                    <span class="fs-12">{{i18n('minutes before sending')}}</span>
                </div>
            </div>
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Transporter')}}:</label>
                <div class="col-sm-9">
                    <select-picker-new :form="form"
                                   :field="'transporter_id'"
                                   :items="transporters"
                                   :value="'id'"
                                   :text="'name'"
                                   :prompt="i18n('Choose a transporter')"
                                   @change="handleTransporterChange"
                                   :filterable="true"
                    >
                    </select-picker-new>
                </div>
            </div>
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Bus')}}:</label>
                <div class="col-sm-9">
                    <select-picker-new :form="form"
                                   :field="'bus_id'"
                                   :items="buses"
                                   :value="'id'"
                                   :text="'bus_number'"
                                   :prompt="i18n('Choose a bus')"
                                   :disabled="buses.length === 0"
                                   :filterable="true"
                                   @change="handleBusChange">
                    </select-picker-new>
                </div>
            </div>
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12" for="driver_id">{{i18n('Driver')}}:</label>
                <div class="col-sm-9">
                    <input type="text" class="form-control base_input" id="driver_id" :value="driver" disabled>
                </div>
            </div>
            <div class="form-group form-row">
                <label class="col-sm-3 col-form-label fs-12 pt-12" for="customCheck1"></label>
                <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="generate_to_finish">
                        <label class="custom-control-label" for="customCheck1" @click="generateToFinish">{{i18n('Generate to finish')}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SelectPicker from '../../../components/SelectPicker';
    import SelectPickerNew from '../../../components/SelectPickerNew';
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import FormInput from '../../../components/FormInput';
    import VCalendar from 'v-calendar';
    import DateTime from "../../../components/DateTime";

    export default {
        name: "ScheduleMain",
        components: {SelectPicker, SelectPickerNew, Datepicker, FormInput, VCalendar},
        props: {
            form: {
                type: Object,
                required: true
            },
            isUpdate: {
                type: Boolean,
                required: true
            },
            generatedFor: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                monthRegularityType: 1,
                transporters: [],
                buses: [],
                driver: '',
                days: [],
                demoDays: [],
                availableDays: [],
                daysArray: [],
                customDays: '',
                range: {
                    start: this.$moment(),
                    end: this.$moment(),
                },
                isRangeMode: true,
                custom_seats: '',
                generate_to_finish: false,
                daysArrayMinDate: new Date(),
            }
        },
        created() {
            this.getTransporters();
            this.getRegularityTypes();
        },
        methods: {
            getTransporters() {
                this.$api.get('transporters.index')
                    .then(res => {
                        this.transporters = res.data;
                    });
            },
            getRegularityTypes() {
                this.$api.get('schedule-trips.regularity-types')
                    .then(res => {
                        this.$store.commit('setRegularityTypes', res.data);
                    });
            },
            handleRegularityType() {
                switch (this.form.trip_regularity_type) {
                    case 1:
                        this.form.days = null;
                        break;
                    case 2:
                        this.form.days = 2;
                        break;
                    case 3:
                        this.form.days = [];
                        break;
                    case 4:
                        this.form.days = {
                            type: 1,
                            days: []
                        };
                        break;
                    case 5:
                        this.form.days = [];
                }
            },
            handleTransporterChange() {
                let transporter = this.transporters.find(item => item.id === this.form.transporter_id);
                this.buses = transporter ? transporter.buses : [];
            },
            handleBusChange() {
                let bus = this.buses.find(item => item.id === this.form.bus_id);
                this.driver = bus ? bus.driver.name : '';
                this.form.driver_id = bus ? bus.driver.id : '';
            },
            splitDays() {
                this.form.days.days = this.splitData(this.customDays);
                this.setMonthDays();
            },
            splitSeats() {
                this.form.reserved_seats = this.splitData(this.custom_seats);
            },
            splitData(data) {
                let byComma = data.split(',');
                let dataArray = [];
                let byDash = [];
                byComma.forEach(item => {
                    let dash = item.indexOf('-');
                    if (dash >= 0) {
                        byDash = item.split('-');
                        let first = parseInt(byDash[0]);
                        let second = parseInt(byDash[1]);
                        if (first > 0 && second > 0) {
                            if (first < second)
                                for (let i = first; i <= second; i++)
                                    dataArray.push(i);
                            else
                                for (let i = second; i <= first; i++)
                                    dataArray.push(i);
                        } else {
                            if (first > 0) dataArray.push(first);
                            if (second > 0) dataArray.push(second);
                        }
                    } else {
                        dataArray.push(parseInt(item));
                    }
                });
                dataArray = dataArray.filter((v, i, a) => a.indexOf(v) === i);
                dataArray.sort((a, b) => {
                    return a - b
                });

                return dataArray;
            },
            setEveryDays() {
                this.demoDays = [];
                let start = this.$moment(this.form.begin_at);
                let end = start.diff(this.form.finish_at, 'days') * -1;
                let item = start.format();
                for (let i = 0; i <= end; i++) {
                    this.demoDays.push(new Date(item));
                    item = start.add(1, 'days').format();
                }
                this.availableDays = this.demoDays;
            },
            setIntervalDays() {
                this.demoDays = [];
                let start = this.$moment(this.form.begin_at);
                let end = start.diff(this.form.finish_at, 'days') * -1 / this.form.days;
                let item = start.format();
                for (let i = 0; i <= end; i++) {
                    this.demoDays.push(new Date(item));
                    item = start.add(this.form.days, 'days').format();
                }
                this.availableDays = this.demoDays;
            },
            setWeekDays() {
                this.demoDays = [];
                let start = this.$moment(this.form.begin_at);
                let end = start.diff(this.form.finish_at, 'days') * -1;
                let item = start.format();
                for (let i = 0; i <= end; i++) {
                    if (this.form.days[start.weekday()]) {
                        this.demoDays.push(new Date(item));
                    }
                    item = start.add(1, 'days').format();
                }
                this.availableDays = this.demoDays;
            },
            setMonthDays() {
                this.demoDays = [];
                let start = this.$moment(this.form.begin_at);
                let end = start.diff(this.form.finish_at, 'days') * -1;
                let item = start.format();
                for (let i = 0; i <= end; i++) {
                    switch (this.monthRegularityType) {
                        case 1:
                            if (this.form.days.days.indexOf(start.date()) >= 0) {
                                this.demoDays.push(new Date(item));
                            }
                            break;
                        case 2:
                            if (start.date() % 2 === 0) {
                                this.demoDays.push(new Date(item));
                            }
                            break;
                        case 3:
                            if (start.date() % 2 === 1) {
                                this.demoDays.push(new Date(item));
                            }
                    }
                    item = start.add(1, 'days').format();
                }
                this.availableDays = this.demoDays;
            },
            incrementDays() {
                this.form.days++;
                this.setIntervalDays();
            },
            decrementDays() {
                this.form.days > 2 ? this.form.days-- : '';
                this.setIntervalDays();
            },
            handleFormUpdate() {
                this.handleTransporterChange();
                this.handleBusChange();
                this.range.start = this.form.begin_at;
                this.range.end = this.form.finish_at;
                if (this.form.trip_regularity_type === 4) {
                    this.monthRegularityType = this.form.days.type;
                }
            },
            handleRangeChange() {
                this.form.begin_at = this.range.start;
                this.form.finish_at = this.$moment(new Date(this.range.end)).set({hour: 23, minute: 59, second: 59}).format('Y-MM-DD H:mm');
                switch (this.form.trip_regularity_type) {
                    case 1:
                        this.setEveryDays();
                        break;
                    case 2:
                        this.setIntervalDays();
                        break;
                    case 3:
                        this.setWeekDays();
                        break;
                    case 4:
                        this.setMonthDays();
                        break;
                    case 5:
                        this.demoDays = [];
                }
                this.isRangeMode = false;
            },
            generateToFinish(e) {
                if (this.form.generate_to_finish === false && confirm('Вы действительно генерироват до конца периода? Тогда для этого расписание автогенерация не работает.')) {
                    this.form.generate_to_finish = true;
                } else {
                    this.form.generate_to_finish = false;
                    this.generate_to_finish = false;
                    e.preventDefault();
                }
            }
        },
        watch: {
            daysArray: function (val) {
                if (val) {
                    val = val.map(item => {
                        return this.$moment(item).format('YYYY-MM-DD');
                    });
                } else {
                    val = [];
                }
                this.form.days = val;
            },
            range: {
                handler: function () {
                    this.handleRangeChange();
                },
                deep: true,
            },
            monthRegularityType: function () {
                this.setMonthDays();
            },
            'form.trip_regularity_type': function (val) {
                switch (val) {
                    case 1:
                        this.setEveryDays();
                        break;
                    case 2:
                        this.setIntervalDays();
                        break;
                    case 3:
                        this.setWeekDays();
                        break;
                    case 4:
                        this.setMonthDays();
                        break;
                    case 5:
                        this.demoDays = [];
                }
            },
            isUpdate: function (val) {
                if (val === true) {
                    this.handleFormUpdate();
                }
            },
            generatedFor: function (val) {
                if (val) {
                    this.daysArrayMinDate = new Date(val);
                }
            }
        }
    }
</script>

<style scoped>
    @import '~v-calendar/lib/v-calendar.min.css';

    .back_link {
        color: #00aced;
        font-size: 13px;
        align-self: flex-end;
    }
</style>
